import moment from 'moment';

export const dateTrim = (date = new Date(), format = 'DD/MM/YYYY'): string => {
  return moment(date).format(format);
};
